import { ComboBox, CommandBarButton, Dropdown, IComboBoxOption, Label, Stack } from '@fluentui/react';
import * as React from 'react'
import { useTranslation } from 'react-i18next';
import '../css/controll/paging.scss'
export interface PagingProps {
    onChangePage: (page: number, pageSize: number) => void,
    TotalPage: number,
    CurrentPage: number | undefined,
}
const Paging = ({ onChangePage, TotalPage, CurrentPage }: PagingProps) => {
    const { t } = useTranslation();
    const [PageSize, setPageSize] = React.useState(20)
    const [Page, setPage] = React.useState(1)
    const getListPage = (): IComboBoxOption[] => {
        const options: IComboBoxOption[] = [];
        for (let index = 1; index <= TotalPage; index++) {
            options.push({ key: index, text: index.toString() })
        }
        return options;
    }
    React.useEffect(() => {
        setPage(CurrentPage || 0);
    }, [CurrentPage]);
    const getPage = (p: number): number => {
        let page = p <= 0 ? 1 : p
        page = page >= TotalPage ? TotalPage : page
        return page;
    }
    return (
        <>
            {(TotalPage > 0) && (
                <Stack horizontal className="pagging ms-Grid flex-center">
                    <div className={"flex-center"} >
                        <Dropdown style={{ width: 70 }} onChange={(e, otp) => {
                            let page = (otp?.key || 20) as number
                            setPageSize(page);
                            onChangePage(1, page);
                            setPage(1);
                        }}
                            selectedKey={PageSize} options={[
                                { key: 10, text: '10' },
                                { key: 20, text: '20' },
                                { key: 50, text: '50' }
                            ]}>
                        </Dropdown>
                        &nbsp;
                        &nbsp;
                        <span>{t('ItemsPerPage')}</span>
                    </div>
                    <div className={"flex-center"} style={{ marginLeft: 'auto' }}>
                        <CommandBarButton iconProps={{ iconName: 'DoubleChevronLeftMed' }} onClick={() => {
                            setPage(1);
                            onChangePage(1, PageSize);
                        }} />
                        <CommandBarButton iconProps={{ iconName: 'ChevronLeftMed' }} onClick={() => {
                            let page = Page - 1;
                            setPage(getPage(page));
                            onChangePage(getPage(page), PageSize);
                        }} />
                        &nbsp;
                        <ComboBox
                            selectedKey={Page}
                            options={getListPage()}
                            style={{ width: 80 }}
                            allowFreeform={true}
                            calloutProps={{ doNotLayer: true }}
                            onChange={(event, option, index, value) => {
                                let page = parseInt(option?.key.toString() || Page.toString());
                                onChangePage(getPage(page), PageSize);
                                setPage(getPage(page));
                            }}
                        />
                        &nbsp;
                        &nbsp;
                        <span className={"paging-lable"}>{t("Of")}</span>
                        &nbsp;
                        <span className={"paging-lable"}>{TotalPage}</span>
                        &nbsp;
                        <CommandBarButton iconProps={{ iconName: 'ChevronRightMed' }} onClick={() => {
                            let page = Page + 1;
                            onChangePage(getPage(page), PageSize);
                            setPage(getPage(page));
                        }} />
                        <CommandBarButton iconProps={{ iconName: 'DoubleChevronLeftMedMirrored' }} onClick={() => {
                            onChangePage(TotalPage, PageSize);
                            setPage(TotalPage);
                        }} />
                    </div>
                </Stack>)}
        </>
    );
}
export default Paging;